import React, { useState } from 'react';
import { LuCalendar, LuChevronDown } from 'react-icons/lu';
import './DateRangeFilter.css';

function toISODate(date) {
  return date.toISOString().slice(0, 10);
}

function formatDisplay(iso) {
  const [y, m, d] = iso.split('-');
  return `${d}/${m}/${y}`;
}

const PRESETS = [
  {
    key: 'thisMonth',
    label: 'Este mês',
    range: () => {
      const now = new Date();
      return { start: toISODate(new Date(now.getFullYear(), now.getMonth(), 1)), end: toISODate(now) };
    },
  },
  {
    key: 'lastMonth',
    label: 'Mês passado',
    range: () => {
      const now = new Date();
      return {
        start: toISODate(new Date(now.getFullYear(), now.getMonth() - 1, 1)),
        end: toISODate(new Date(now.getFullYear(), now.getMonth(), 0)),
      };
    },
  },
  {
    key: 'thisYear',
    label: 'Este ano',
    range: () => {
      const now = new Date();
      return { start: toISODate(new Date(now.getFullYear(), 0, 1)), end: toISODate(new Date(now.getFullYear(), 11, 31)) };
    },
  },
  {
    key: 'all',
    label: 'Tudo (desde o início)',
    // Data bem anterior à loja existir — cobre todo o histórico. O backend
    // agrupa automaticamente por ano quando o intervalo é grande assim.
    range: () => ({ start: '2015-01-01', end: toISODate(new Date()) }),
  },
  { key: 'custom', label: 'Personalizado' },
];

const DateRangeFilter = ({ startDate, endDate, onChange }) => {
  const [open, setOpen] = useState(false);
  const [selectedPreset, setSelectedPreset] = useState('thisMonth');

  const handleSelect = (preset) => {
    setSelectedPreset(preset.key);
    if (preset.key !== 'custom') {
      const range = preset.range();
      onChange(range.start, range.end);
      setOpen(false);
    }
  };

  const currentLabel = PRESETS.find((p) => p.key === selectedPreset)?.label || 'Período';

  return (
    <div className="date-range-filter">
      <button type="button" className="date-range-filter__trigger" onClick={() => setOpen((o) => !o)}>
        <LuCalendar size={16} />
        <span>
          {currentLabel}
          {selectedPreset !== 'custom' && ` · ${formatDisplay(startDate)} - ${formatDisplay(endDate)}`}
        </span>
        <LuChevronDown size={14} />
      </button>

      {open && (
        <div className="date-range-filter__menu">
          {PRESETS.map((preset) => (
            <button
              key={preset.key}
              type="button"
              className={`date-range-filter__menu-item${preset.key === selectedPreset ? ' is-active' : ''}`}
              onClick={() => handleSelect(preset)}
            >
              {preset.label}
            </button>
          ))}
        </div>
      )}

      {selectedPreset === 'custom' && (
        <div className="date-range-filter__custom">
          <input
            type="date"
            value={startDate}
            max={endDate}
            onChange={(e) => onChange(e.target.value, endDate)}
            aria-label="Data inicial"
          />
          <span>—</span>
          <input
            type="date"
            value={endDate}
            min={startDate}
            onChange={(e) => onChange(startDate, e.target.value)}
            aria-label="Data final"
          />
        </div>
      )}
    </div>
  );
};

export default DateRangeFilter;
